module.exports = __webpack_public_path__ + "static/media/legende_possible_white.c1a93b26.svg";